import { Component, Injectable, Input, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { AlertService } from '../../../../../app/utils/alert.service';
import { AuthenticationService } from '../../../../../app/services/authentication.service';
import { AdministrationService } from '../../../../../app/services/administration.service';
import { RemoveAdministratorComponent } from '../../../../../app/home/paraEmpresas/administration/remove/content.component';
import { EditAdministratorComponent } from '../../../../../app/home/paraEmpresas/administration/save/content.component';
import { DataPackUserManagerModel } from '../../../../../app/models/data.manager.model';
import { DataPackGroup } from '../../../../../app/models/dataPackGroup.model';

import { BindComponentService } from '../../../../../app/utils/bind.component.service';
import { LoadingComponent } from '../../../../../app/home/paraEmpresas/modalLoading/content.component'; 

  import * as _ from "lodash";


/**
 * @author Wesley Mascarenhas
 * @version $Id: content.component.ts 84172 2018-04-01 17:03:26Z edivaldo.m.junior $
 */
@Component({
  selector:    'listAdministrators',
  templateUrl: './content.template.html'
})
@Injectable()
export class ListAdministratorComponent {

  private static readonly ADMINS_FETCH_SIZE: number = 50;

  private admins: Array<DataPackUserManagerModel> = [];
  private groups: Array<DataPackGroup> = [];
  private filteredAdmins: Array<DataPackUserManagerModel> = [];
  private filterValue: string = '';
  private sortingCriteria: string = null;
  private sortingAsc: boolean = true;
  private hasData:boolean = false;
  private displayShowMoreAdminsButton: boolean = true;
  private adminsFetchSize: number = ListAdministratorComponent.ADMINS_FETCH_SIZE; 
  private abbreviatedDialingService: boolean = false;
  private contractNumber: string;

  constructor(private modalService: NgbModal, private adminService: AdministrationService, private authService: AuthenticationService, private alertService: AlertService, private bindComponent: BindComponentService) {

  }

  ngOnInit() {
    this.bindComponent.subscribe(BindComponentService.FILTER_ADMINISTRATION,
     filter => {
        this.setFilter(filter.value, filter.type);
      }
    );
  }

  private openModalLoading() {
    this.modalService.open(LoadingComponent,{  
      backdrop: 'static',    
      keyboard: false ,
    });
  }

  public loadView() {
    this.openModalLoading();
    this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING,true);
    this.adminService.listAdmins(1, this.adminsFetchSize).subscribe(
      data => {
        this.setAdmins( data['administrators'], false);
        this.setGroups( data['groups'], false);
        this.setHasData( data['hasData']);
        this.displayShowMoreAdminsButton = true;
        this.abbreviatedDialingService = data['abbreviatedDialingService'];
        if (this.abbreviatedDialingService) {
          this.contractNumber = data['contractNumber'];
        }
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING,false);
      },
      err => {
        this.alertService.error(err.result, err);
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING,false);
      }
    );
  }

  private setHasData(hasData: boolean) { 
    this.hasData = hasData;
  }
  private setAdmins(admins: Array<DataPackUserManagerModel>, append: boolean) {
    if (!append) {
      this.admins = admins;
    } else {
      Array.prototype.push.apply(this.admins, admins);
    }
    this.setFilter(this.filterValue);
  }

  private setGroups(groups: Array<DataPackGroup>, append: boolean) {
    if (!append) {
      this.groups = groups;
    } else {
      Array.prototype.push.apply(this.groups, groups);
    }
  }

  public setFilter(text: string, type?: string) {
    this.filterValue = text;
    if (!type) {
      this.filteredAdmins = this.admins.filter(admin => !text || text === '' || this.searchText(admin.name, text) || this.searchText(admin.telNumber, text));
    } else {
      this.filteredAdmins = this.admins.filter(admin => !text || text === '' || type === 'name' ? this.searchText(admin.name, text) : this.searchText(admin.telNumber, text));
    }
  }

  private searchText(text: string, value: string) {
    return text.toLowerCase().search(value.toLowerCase()) != -1;
  }

  private openRemoveModal(model: DataPackUserManagerModel) {
    let modalRef = this.modalService.open(RemoveAdministratorComponent);
    modalRef.componentInstance.model = model;
    modalRef.result.then(result => this.loadView(), reason => null);
  }

  private openEditModal(model: DataPackUserManagerModel) {
    let modalRef = this.modalService.open(EditAdministratorComponent, {backdrop: 'static'});
    modalRef.componentInstance.model = model;
    modalRef.componentInstance.groups = this.groups;
    modalRef.componentInstance.hasData = this.hasData;
    modalRef.result.then(result => this.loadView(), reason => this.loadView());
  }

  private showMoreAdmins(): void {
    this.adminService.listAdmins(this.admins.length + 1, this.adminsFetchSize).subscribe(
      data => {
        this.setAdmins(data['administrators'], true);
        if (data['administrators'].length < this.adminsFetchSize) {
          this.displayShowMoreAdminsButton = false;
        }
      },
      err => {
        this.alertService.error(err.result, err);
      }
    );
  }

  private sortColumn(column: string) {
	  this.sortingAsc = this.sortingCriteria == column ? !this.sortingAsc : true;
	  this.sortingCriteria = column;
    this.filteredAdmins = _.orderBy(this.filteredAdmins, [this.sortingCriteria], [this.sortingAsc ? 'asc' : 'desc']);
  }

  private canRemove(admin: DataPackUserManagerModel) {
    let authenticatedUser  = JSON.parse(localStorage.getItem('GET_AUTENTICATED_USER'));
    return authenticatedUser['user'] !== admin.login;
  }

  private maskMsisdn(msisdn: string): string {
    if(_.isNil(msisdn)) {
      return ''; 
    }
    if(msisdn.length == 12) {
      return '('.concat(msisdn.substr(0,3)).concat(') ').concat(msisdn.substring(3,(msisdn.length -4))).concat('-').concat(msisdn.substr(-4,4));  
    } else if(msisdn.length == 11) {
      return '('.concat(msisdn.substr(0,2)).concat(') ').concat(msisdn.substring(2,(msisdn.length -4))).concat('-').concat(msisdn.substr(-4,4));
    } 
    return msisdn;
  }

  private chooseProfile(profile: string ): string {
    return (profile === 'Master') ? 'Conta' : 'Grupo';
  }
}


// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/administration/list/content.component.ts